import { apiSlice } from './apiSlice'

/** One row of `public.v_report_exposure_limit` (Exposure Limit datasheet). */
export interface ExposureLimit {
  id: number | null
  code: string | null
  name: string | null
  shortName: string | null
  limitDate: string | null
  quantityLimitMt: number | null
  amountLimitUsd: number | null
  limitNote: string | null
  isApproved: number | null
  approvedTxt: string | null
  dateUpdated: string | null
  personUpdated: string | null
}

export interface ExposureLimitListResponse {
  items: ExposureLimit[]
  total: number
  page: number
  pageSize: number
}

/** Edit Limit dialog payload → INSERT a new limit row. */
export interface ExposureLimitWrite {
  code: string
  limitDate: string | null
  quantityLimitMt: number | null
  amountLimitUsd: number | null
  limitNote: string | null
}

export interface ExposureApproveItem {
  id: number
  quantityLimitMt: number | null
  amountLimitUsd: number | null
  limitNote: string | null
}

interface LookupItem {
  value: string
  label: string
}
interface LookupResponse {
  items: LookupItem[]
  total: number
}

const reportExposureApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExposureLimits: builder.query<ExposureLimitListResponse, { page: number; pageSize: number }>({
      query: ({ page, pageSize }) => ({ url: '/report-exposure', params: { page, pageSize } }),
      providesTags: ['ReportExposure'],
    }),
    getExposurePending: builder.query<ExposureLimit[], void>({
      query: () => '/report-exposure/pending',
      providesTags: ['ReportExposure'],
    }),
    getExposureCanApprove: builder.query<{ canApprove: boolean }, void>({
      query: () => '/report-exposure/can-approve',
    }),
    getSpotMonth: builder.query<{ futuresMonth: string | null }, void>({
      query: () => '/report-exposure/spot-month',
      providesTags: ['ReportExposure'],
    }),
    getFuturesMonthOptions: builder.query<LookupResponse, void>({
      query: () => '/report-exposure/lookups/futures-month',
    }),
    createExposureLimit: builder.mutation<{ message: string }, ExposureLimitWrite>({
      query: (body) => ({ url: '/report-exposure', method: 'POST', body }),
      invalidatesTags: ['ReportExposure'],
    }),
    approveExposureLimits: builder.mutation<{ message: string }, { items: ExposureApproveItem[] }>({
      query: (body) => ({ url: '/report-exposure/approve', method: 'POST', body }),
      invalidatesTags: ['ReportExposure'],
    }),
    setSpotMonth: builder.mutation<{ message: string }, { futuresMonth: string }>({
      query: (body) => ({ url: '/report-exposure/spot-month', method: 'POST', body }),
      invalidatesTags: ['ReportExposure'],
    }),
  }),
})

export const {
  useGetExposureLimitsQuery,
  useGetExposurePendingQuery,
  useGetExposureCanApproveQuery,
  useGetSpotMonthQuery,
  useGetFuturesMonthOptionsQuery,
  useCreateExposureLimitMutation,
  useApproveExposureLimitsMutation,
  useSetSpotMonthMutation,
} = reportExposureApi

export default reportExposureApi
